import { Injectable, Output, Input, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { AngularFirestore, AngularFirestoreDocument, AngularFirestoreCollection } from 'angularfire2/firestore';
import { DataModel, IDataModel } from './data.model'
import { TextSearch } from '../comum/textSearch';
import { UsersService } from './usuarios.service';

export interface IResponsavel {
    nome?: string,
    email?: string,
    celular?: string,
}
export interface IFornecedores {
    id?: string,
    token?: string,
    codigo?: number,
    nome?: string,
    razaoSocial?: string,
    missao?: string,
    inativo?: boolean,
    dtatualiz?: Date,
    mostrarMenu?: boolean,
    mostrarMaster?: boolean,
    cobrarFreteAPartir?: number,
    freteMinimo?: number,
    comissao?: number,
    img?: string,
    imgSrc?: string,
    regiao?: any,
    afiliado?: number,
    latitude?: number,
    longitude?: number,
    //responsavel?:IResponsavel,
}

@Injectable()
export class Fornecedores extends DataModel<IFornecedores> {
    users: UsersService;
    constructor(
        private db: AngularFirestore,
        private AVerInativos: boolean = false) {
        super(db, 'fornecedores');
        this.fVerInativo = AVerInativos;
    }

    gerarNovoCodigo(proc) {
        this.getNewID('codigo_fornecedor', proc);
    }

    get verInativo() {
        return this.fVerInativo;
    }
    set verInativo(x: boolean) {
        this.fVerInativo = x;
        //console.log('verInativo', x,'Afliado?:', this.users.isAfiliado,this.users.codigo);
        this.snapshot(
            r => {
                
                if (this.users.isAfiliado) {
                    r = r.where('inativo', '==', this.fVerInativo).where('afiliado', '==', this.users.codigo);
                    //console.log(this.users.perfil, '|' + this.users.codigo + '|');
                }
                else r = r.where('inativo', '==', this.fVerInativo);

                if (this.users.regiaoLogada)
                    r = r.where(this.users.regiaoLogada, '==', true);

                return r;
            }
        );
    }

    getFornecedor(codigo: number, proc) {
        let rt = null;
        this.FDados.forEach(element => {
            if (element.codigo == codigo) {
                rt = element;
                if (proc != null) proc(rt);
                return rt;
            }
        });

        /// nao esta na memoria ?
        if (rt == null) {
            //console.log('Procurar por:', this.tableNameFull, codigo);
            let qry = this.db.collection(this.tableNameFull,
                r => r.where("codigo", "==", codigo));
            this.openQuery(qry.ref, d => {
                d.forEach(elm => {
                    this.FDados.push(elm);
                    if (elm.codigo == codigo)
                        proc(elm);
                });
            });
        }

    }


    _beforeChange(item){
        item.codigo = Number(item.codigo);
        item.inativo = (item.inativo?item.inativo:false);
        item.search = TextSearch.decode(item.nome);
        return item;
    }

    add(item, proc?: any, errProc?: any): Promise<any> {
        return super.add(this._beforeChange(item), proc, errProc);
    }

    post(item: any, proc?: any, errProc?: any): Promise<any> {
        if (item.afiliado)
           item.afiliado = parseFloat(item.afiliado);
        return super.post(this._beforeChange(item), proc, errProc);
    }

    updateOrInsert(id, item, proc?, err?, merge=false) {
        if (item.afiliado)
           item.afiliado = parseFloat(item.afiliado);
        return super.updateOrInsert(id, this._beforeChange(item), proc, err, merge);
    }
}
